<template>
    <Card title="Leads" class="flex-fill mt-4">
        <h1 class="text-center" v-if="loading"><i class="fas fa-spinner fa-pulse"></i></h1>
        <h4 class="text-danger text-center" v-if="showError">There was an error loading leads</h4>
        <div class="scroll">
            <table v-if="!loading && !showError" class="table table-striped table-borderless">
                <thead>
                <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Listing</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(lead, index) in leads" v-bind:key="index">
                    <th scope="row" ignore>{{lead.name}}</th>
                    <td class="text-success" ignore>{{lead.address}}</td>
                </tr>
                </tbody>
            </table>
        </div>

        <template #footer>
            <a class="text-success float-right" :href="`${cpixdomain}/aspen/leads.htm`">View All</a>
        </template>
    </Card>
</template>

<script>

import Card from './Card';
import {cpixdomain} from "../config";

export default {
    name: 'LeadCard',
    components: {
        Card
    },
    data: function() {
        return {
            leads: null,
            loading: true,
            showError: false,
            days: 714, //102 weeks just like in aspen
        }
    },
    computed: {
        cpixdomain() {
            return cpixdomain
        }
    },
    mounted: function() {
        this.$http.get('/leads?daysBack=' + this.days)
            .then(res => {
                this.leads = res.data;
            }).catch(() => {
                this.showError = true;
            }).finally(() => {
                this.loading = false;
            });
    }
}
</script>

<style>
    .scroll {
        max-height: 200px;
        overflow-y: scroll;
    }
</style>

